<template>
    <div class="web-top-bar">
        <div class="web-top-bar-box">
            <!-- 左边部分菜单 -->
            <div class="web-top-bar-left">
                <span class="web-top-bar-item web-top-bar-item-b" @click="clickWebIndex">名人百科首页</span>
                <span class="web-top-bar-item" @click="clickCollate">八字起盘</span>
                <span class="web-top-bar-item" @click="clickRecord">我的八字库</span>
                <span class="web-top-bar-item web-top-bar-item-org" @click="clickReport">智能测算</span>
            </div>

            <!-- 右边部分菜单 -->
            <div class="web-top-bar-right">
                <span class="web-top-bar-item web-top-bar-item-green" @click="goDownload">下载天时子平八字</span>
                <span v-if="!userData || !userData.token" class="web-top-bar-item" @click="clickLogin">登录</span>
                <span v-else>
                    <span v-if="userData.info" class="web-top-bar-avatar" @click="clickAvatar">
                        <img class="web-top-bar-avatar-img" v-bind:src="userData.info.avatar" alt="">{{userData.info.nickname}}
                    </span>
                    <span @click="clickInform" class="famous-pedia-rwp-right-item"><i class="iconfont icon-my"></i></span>
                    <span @click="clickMyFamousPedia(4)" class="famous-pedia-rwp-right-item"><i class="iconfont icon-bell2"></i></span>
                    <span @click="clickMyFamousPedia(3)" class="famous-pedia-rwp-right-item"><i class="iconfont icon-star2"></i></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '../modules/config';
import { DOM } from '../modules/dom';
export default {
    name: 'WebTopBar',
    computed: {
        userData() {
            return this.$store.state.userData;
        }
    },
    data() {
        return {
            showOperate: false
        }
    },
    methods: {
        clickWebIndex() {
            this.$router.replace('/webhome');
        },
        clickCollate() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    DOM.showPageByClassName('collate-page');
                    me.$router.replace('/collate');
                }
            });
        },
        clickRecord() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$router.replace('/record');
                }
            });
        },
        clickReport() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    DOM.showPageByClassName('collate-page');
                    me.$router.replace('/collate');
                }
            });
        },
        goDownload() {
            if(this.$store.state.weblogin.curWebFamousPediaMenu == 6) {
                return;
            }
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            this.$store.state.weblogin.curWebFamousPediaMenu = 6;
            var me = this;
            setTimeout(() => {
                me.$bus.emit('createQrCode');
            }, 10);
            // window.open(CONFIG.download_url);
        },
        clickLogin() {
            this.$store.dispatch('weblogin/checkWebLogin');
        },
        clickMyFamousPedia(menuId) {
            this.showPop();
            this.$store.state.weblogin.curWebFamousPediaMenu = menuId == 3 ? 1 : 2;
            this.$store.dispatch('famouspedia/initCurPediaList', {
                curId: menuId,
                cb: function() {
                    setTimeout(() => {
                        var listDom = document.getElementById('FamousVirtualList');
                        if(listDom) {
                            listDom.style.height = '480px';
                        }
                    }, 100);
                }
            });
        },
        clickInform() {
            this.showPop();
            this.$store.state.weblogin.curWebFamousPediaMenu = 3;
            this.$store.dispatch('inform/getMsgList', {
                cb: function() {
                    setTimeout(() => {
                        var listDom = document.getElementById('FamousInformList');
                        if(listDom) {
                            listDom.style.height = '480px';
                        }
                    }, 100);
                }
            });
        },
        clickAvatar() {
            this.showPop();
            this.$store.state.weblogin.curWebFamousPediaMenu = 5;
        },
        showPop() {
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            // var me = this;
            // setTimeout(() => {
            //     me.$store.state.weblogin.showWebFamousPediaPop = false;
            // }, 5000);
        }
    }
}
</script>